
export default {
  name: state => state.user.name,
}
